import React, { useEffect, useState } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
    Spinner,
} from 'reactstrap';
import Header from '../shared/Header';
import HeaderProceso from './components/HeaderProceso';
import { listOperacionesPorProceso } from '../pld/api/pldApi';

function formatFechaApertura(v) {
    if (!v) {
        return '—';
    }
    try {
        return new Date(v).toLocaleString('es-MX', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        });
    } catch (_) {
        return String(v);
    }
}

export default function VistaPLDProceso() {
    const { unidad, procesoId } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [operaciones, setOperaciones] = useState([]);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            if (!unidad || !procesoId) {
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const data = await listOperacionesPorProceso(unidad, procesoId);
                if (!cancelled) {
                    setOperaciones(Array.isArray(data) ? data : []);
                }
            } catch (err) {
                if (!cancelled) {
                    const msg =
                        (err.response &&
                            err.response.data &&
                            err.response.data.error) ||
                        err.message ||
                        'No se pudo cargar el expediente PLD.';
                    setError(String(msg));
                    setOperaciones([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }
        load();
        return () => {
            cancelled = true;
        };
    }, [unidad, procesoId]);

    const principal = operaciones[0];

    function handleIniciar() {
        history.push(`/${unidad}/pld/nuevo?proceso_id=${encodeURIComponent(procesoId)}`);
    }

    return (
        <Container className="pb-5">
            <HeaderProceso unidad={unidad} procesoId={procesoId} />
            <Header>PLD — Expediente vinculado</Header>

            {loading ? (
                <div className="d-flex align-items-center text-muted py-4">
                    <Spinner size="sm" color="secondary" className="mr-2" />
                    Cargando estado PLD…
                </div>
            ) : error ? (
                <p className="text-danger">{error}</p>
            ) : !principal ? (
                <Card className="shadow-sm">
                    <CardBody>
                        <p className="mb-3">
                            No hay expediente PLD vinculado a este proceso. Puede
                            iniciar uno; quedará asociado automáticamente.
                        </p>
                        <Button color="primary" onClick={handleIniciar}>
                            Iniciar expediente PLD
                        </Button>
                    </CardBody>
                </Card>
            ) : (
                <Card className="shadow-sm">
                    <CardHeader className="font-weight-bold">
                        Expediente en curso
                    </CardHeader>
                    <CardBody>
                        <Row className="mb-2">
                            <Col xs="12" sm="4" className="text-muted small">
                                Asunto
                            </Col>
                            <Col xs="12" sm="8">
                                {principal.asunto || '—'}
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs="12" sm="4" className="text-muted small">
                                Tipo de operación
                            </Col>
                            <Col xs="12" sm="8">
                                {principal.tipo_operacion || '—'}
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs="12" sm="4" className="text-muted small">
                                Denominación
                            </Col>
                            <Col xs="12" sm="8">
                                {principal.denominacion || '—'}
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs="12" sm="4" className="text-muted small">
                                Estado
                            </Col>
                            <Col xs="12" sm="8">
                                {principal.estado || '—'}
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col xs="12" sm="4" className="text-muted small">
                                Apertura
                            </Col>
                            <Col xs="12" sm="8">
                                {formatFechaApertura(principal.fecha_apertura)}
                            </Col>
                        </Row>
                        <Button
                            tag={Link}
                            color="primary"
                            outline
                            to={`/${unidad}/pld/${principal.id}`}
                        >
                            Abrir expediente completo
                        </Button>
                        {operaciones.length > 1 ? (
                            <p className="small text-muted mt-3 mb-0">
                                Hay {operaciones.length} operaciones con este
                                proceso; se muestra la más reciente. Use el
                                tablero PLD para revisar el historial.
                            </p>
                        ) : null}
                    </CardBody>
                </Card>
            )}
        </Container>
    );
}
